module.exports = {
	data:function(){
		return {
			title:'404'
		}
	},
	route:{
		activate:function(transition){
			this.$root.$set('header',this.title);
			transition.next();
		}
	},
};


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/views/not_found.vue
// module id = 114
// module chunks = 0